import React from "react";
import { CheckCircleIcon, CircleCheck, LinkIcon, PhoneCallIcon, SearchX } from "lucide-react";
import LawfirmProfileReview from "./LawfirmProfileReview";


function LawFirmMatches({
  matchingFirms,
  values,
  setFieldValue
}) {
  

  return (
    <div className="sm:p-6">
        <LawfirmProfileReview values={values} />
        {!matchingFirms?.length ? (
          <div>
            <div className="flex items-center gap-3 rounded-lg border border-gray-200 bg-cream px-4 py-3 text-sm text-gray-600">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white">
            <SearchX className="h-5 w-5 text-tan" />
        </div>

        <div>
            <p className="font-medium text-navy">
            No matches found
            </p>
            <p className="text-xs mt-2 text-gray-500">
            You can safely continue with your submission or edit your law firm info to try again.
            </p>
        </div>
        </div>
        </div>)
        : 
      <div className="space-y-3 p-2">
        {/* <div className="mb-2 text-sm text-sky-600 mt-2 font-bold"  >
            Firms matching that matches your law firm entry.
            </div> */}
        {matchingFirms.map((firm) => {
          const selected = values.lawFirmId === firm._id;
          return (
            <label
              key={firm._id}
              className={`relative flex text-sm cursor-pointer rounded-xl border p-3 transition-all duration-150
              ${
                selected
                  ? "border-tan bg-cream shadow-sm"
                  : "border-gray-200 bg-white hover:border-tan/50"
              }`}
            >
              <input
                type="radio"
                name="firm"
                value={firm._id}
                checked={selected}
                onChange={(e) => setFieldValue("lawFirmId", e.target.value)}
                className="sr-only"
              />

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-3">
                  <h4 className="font-medium text-navy break-words">
                    {firm.name}
                  </h4>

                  {selected && (
                    <CircleCheck className="h-5 w-5 text-tan flex-shrink-0" />
                  )}
                </div>

                <div className="mt-2 space-y-1 text-sm text-gray-600">
                  {firm.website && (
                    <div className="flex items-center gap-2">
                      <LinkIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />
                      <span className="truncate">
                        {firm.website}
                      </span>
                    </div>
                  )}

                  {firm.phone && (
                    <div className="flex items-center gap-2">
                      <PhoneCallIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />
                      <span>{firm.phone}</span>
                    </div>
                  )}
                </div>
              </div>
            </label>
          );
        })}

        {/* None Option */}

        <label
          className={`relative flex text-sm cursor-pointer rounded-xl border p-3 transition-all duration-150
          ${
            values.lawFirmId === null
              ? "border-tan bg-cream shadow-sm"
              : "border-gray-200 bg-white hover:border-tan/50"
          }`}
        >
          <input
            type="radio"
            name="firm"
            value="none"
            checked={values.lawFirmId === null}
            onChange={() =>
              setFieldValue("lawFirmId", null)}
            className="sr-only"
          />

          <div className="flex-1">
            <div className="flex items-start text-xs justify-between gap-3">
              <h4 className="font-medium underline text-navy">
                Can't find your law firm?
              </h4>
            </div>

            <p className="mt-2 text-xs text-gray-600">
              Continue with submission safely.
            </p>
          </div>
        </label>
      </div>
        }
    </div>
  );
}

export default LawFirmMatches;